module.exports = () => {
  return {
    image_url: {
      label: '卡片主图',
      type: 'form-upload',
      props: {
        accept: '.jpg, .jpeg, .png',
        tip: '尺寸要求宽高比例为1:1，格式为jpg/jpeg/png，文件大小小于5M',
        restriction: {
          width_ratio: 1,
          height_ratio: 1,
          max_size: 5 * 1024 * 1024,
          type: ['image/jpeg', 'image/png'],
        },
      },
      value: { url: '' },
      rules: {
        required: true,
        trigger: ['change'],
        validator: (_, value, callback) => {
          if (!value.url) {
            callback(new Error('请选择卡片主图'));
          } else {
            callback();
          }
        },
      },
    },
    component_type: {
      label: '组件类型',
      type: 'radio-group',
      isButton: true,
      props: {
        disabled: true,
      },
      options: [
        { label: '通用基础卡', value: '2' },
      ],
      value: '',
    },
    component_name: {
      label: '组件名称',
      type: 'input',
      props: {
        placeholder: '请输入组件名称',
        showWordLimit: true,
        maxlength: 20,
      },
      value: '',
      rules: { required: true, trigger: ['change'], message: '请输入组件名称' },
    },
    title: {
      label: '卡片标题',
      type: 'input',
      props: {
        placeholder: '请输入卡片标题',
        showWordLimit: true,
        maxlength: 15,
      },
      value: '',
      rules: { required: true, trigger: ['change'], message: '请输入卡片标题' },
    },
    description: {
      label: '卡片描述',
      type: 'input',
      props: {
        placeholder: '请输入卡片描述',
        showWordLimit: true,
        maxlength: 20,
      },
      value: '',
      rules: { required: true, trigger: ['change'], message: '请输入卡片描述' },
    },
    keywords: {
      label: '推广卖点',
      type: 'form-tags',
      props: {
        direction: 'column',
        multiple: false,
        showWordLimit: true,
        minlength: 1,
        maxlength: 6,
        tagsNum: 10,
      },
      value: [],
      rules: { required: true, message: '请添加产品卖点', trigger: ['change'] },
    },
    button_id: {
      label: '按钮文案',
      type: 'select',
      props: {
        clearable: false,
        filterable: true,
      },
      options: [],
      value: '',
      rules: { required: true, trigger: ['change'], message: '请选择按钮文案' },
    },
  };
};
